import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AdminApiService } from './admin-api.service';
import { MenuItemAdmin, MenuItemResponse, RoleMenuAccessRequest } from '../interface/menu-item.interface';

/**
 * Servicio para gestión dinámica del menú.
 *
 * - getMyMenu(): usado por el Sidebar para obtener el menú del usuario autenticado.
 * - getAdminItems(): usado por la pantalla de administración.
 * - updateRoleMenuAccess(): reemplaza la asignación completa de un rol.
 * - addItemToRole() / removeItemFromRole(): operaciones granulares.
 */
@Injectable({ providedIn: 'root' })
export class MenuAccessService {
  private readonly myMenuPath   = environment.admin_conf.MENU_MY_MENU;
  private readonly adminPath    = environment.admin_conf.MENU_ADMIN_ITEMS;
  private readonly accessPath   = environment.admin_conf.MENU_ADMIN_ROLE_ACCESS;

  constructor(private readonly api: AdminApiService) {}

  /** Retorna el árbol de menú para el usuario autenticado */
  getMyMenu(): Observable<MenuItemResponse[]> {
    return this.api.get<MenuItemResponse[]>(this.myMenuPath);
  }

  /** Lista todos los ítems con su configuración de acceso (panel admin) */
  getAdminItems(): Observable<MenuItemAdmin[]> {
    return this.api.get<MenuItemAdmin[]>(this.adminPath);
  }

  /** Reemplaza completamente los ítems de un rol */
  updateRoleMenuAccess(request: RoleMenuAccessRequest): Observable<void> {
    return this.api.put<void>(this.accessPath, request);
  }

  /** Agrega un ítem a un rol */
  addItemToRole(roleId: number, menuItemId: number): Observable<void> {
    return this.api.post<void>(`${this.accessPath}/${roleId}/item/${menuItemId}`, {});
  }

  /** Elimina un ítem de un rol */
  removeItemFromRole(roleId: number, menuItemId: number): Observable<void> {
    return this.api.delete(`${this.accessPath}/${roleId}/item/${menuItemId}`);
  }
}
